import React from 'react';
import { useSelector } from 'react-redux';

// components
import { FormRow } from '../components/layout';
import { TextInput, Checkbox } from '../components/inputs';
import { AgreementsBox } from '../../../common/components';

function InPersonAgreements() {
  const { plan } = useSelector(store => store);
  const { esignMaterialID } = useSelector(store => store.theme);

  return (
    <>
      <hr />
      <h4 className="mb-2">Agreements</h4>
      <p>You must read the disclosures below and check the box to confirm you have done so.</p>
      <FormRow>
        <AgreementsBox plan={plan} />
      </FormRow>
      <FormRow>
        <p>I have read and understand the important information on the preceding pages. I have reviewed and received a copy of the Summary of Benefits.</p>
        <Checkbox
          name="esign_agree"
        />
      </FormRow>
      <h4>E-Signature</h4>
      <FormRow className="mb-6">
        <TextInput
          name="esign_signature"
          cols="6"
        />
        <div className="d-flex col-md-6 align-items-end justify-content-end">
          <span className="fs-5 text-muted">
            {esignMaterialID}
          </span>
        </div>
      </FormRow>
    </>
  );
}

export default InPersonAgreements;
